<template>
	<q-layout-footer>
		<q-toolbar
			class="q-py-lg footer-desktop mobile-hide"
			:style="$q.platform.is.edge ? 'height: 180px' : ''"
		>
			<div class="row fit justify-center">
				<div class="col-sm-10">
					<div class="row gutter-md">
						<div class="col-3">
							<div class="row  gutter-xs flex justify-center">
								<div class=" col-12 logo text-center">
									<img :src="getLogo" class="logo-footer-desktop" />
								</div>

								<!-- Portugues -->
								<div
									class="col-6"
									v-if="urlStoreGoogle && id_user_language_selected == 1"
								>
									<a :href="urlStoreGoogle">
										<img
											src="~assets/store_icons/google_portugues.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<div
									class="col-6"
									v-if="useAppleCodes && id_user_language_selected == 1"
								>
									<a
										href="#"
										@click.prevent="open_modal()"
										style="cursor: pointer;"
									>
										<img
											src="~assets/store_icons/app_portugues.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<div
									class="col-6"
									v-else-if="urlStoreApple && id_user_language_selected == 1"
								>
									<a :href="urlStoreApple" target="_blank">
										<img
											src="~assets/store_icons/app_portugues.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<!-- English -->
								<div
									class="col-6"
									v-if="urlStoreGoogle && id_user_language_selected == 2"
								>
									<a :href="urlStoreGoogle">
										<img
											src="~assets/store_icons/google_ingles.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<div
									class="col-6"
									v-if="useAppleCodes && id_user_language_selected == 2"
								>
									<a
										href="#"
										@click.prevent="open_modal()"
										style="cursor: pointer;"
									>
										<img
											src="~assets/store_icons/app_ingles.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<div
									class="col-6"
									v-else-if="urlStoreApple && id_user_language_selected == 2"
								>
									<a :href="urlStoreApple" target="_blank">
										<img
											src="~assets/store_icons/app_ingles.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<!-- Español -->
								<div
									class="col-6"
									v-if="urlStoreGoogle && id_user_language_selected == 3"
								>
									<a :href="urlStoreGoogle">
										<img
											src="~assets/store_icons/google_espanhol.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<div
									class="col-6"
									v-if="useAppleCodes && id_user_language_selected == 3"
								>
									<a
										href="#"
										@click.prevent="open_modal()"
										style="cursor: pointer;"
									>
										<img
											src="~assets/store_icons/app_espanhol.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<div
									class="col-6"
									v-else-if="urlStoreApple && id_user_language_selected == 3"
								>
									<a :href="urlStoreApple" target="_blank">
										<img
											src="~assets/store_icons/app_espanhol.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<!-- Fraçais -->
								<div
									class="col-6"
									v-if="urlStoreGoogle && id_user_language_selected == 4"
								>
									<a :href="urlStoreGoogle">
										<img
											src="~assets/store_icons/google_frances.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<div
									class="col-6"
									v-if="useAppleCodes && id_user_language_selected == 4"
								>
									<a
										href="#"
										@click.prevent="open_modal()"
										style="cursor: pointer;"
									>
										<img
											src="~assets/store_icons/app_frances.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<div
									class="col-6"
									v-else-if="urlStoreApple && id_user_language_selected == 4"
								>
									<a :href="urlStoreApple" target="_blank">
										<img
											src="~assets/store_icons/app_frances.png"
											style="width: 100%"
										/>
									</a>
								</div>
							</div>
						</div>

						<div class="col-3">
							<h5 class="no-margin q-pb-md">{{ $t('institutional') }}</h5>

							<p v-for="(inst, index) in institutional" :key="index">
								<router-link :to="{ name: inst.to }">{{
									$t(inst.name)
								}}</router-link>
							</p>
						</div>

						<div class="col-3">
							<h5 class="no-margin q-pb-md">{{ $t('questions') }}</h5>

							<p v-for="(question, index) in questions" :key="index">
								<router-link :to="{ name: question.to }">{{
									$t(question.name)
								}}</router-link>
							</p>
						</div>

						<div class="col-3">
							<h5 class="no-margin q-pb-md">{{ $t('access') }}</h5>

							<p v-for="(link, index) in links" :key="index" v-if="showLink(link.to)">
								<router-link :to="{ name: link.to }">{{
									$t(link.name)
								}}</router-link>
							</p>
						</div>
					</div>
				</div>
			</div>
		</q-toolbar>

		<q-toolbar class="mobile-hide bg-primary" style="padding: 0px; min-height: 30px;">
			<q-toolbar-title class="text-center text-weight-light">
				<small
					>Copyright © {{ new Date().getFullYear() }}: {{ getProjectName }} v{{
						getVersion
					}}
					- Powered by <a href="https://take5.com.br">Take 5 LMS</a></small
				>
			</q-toolbar-title>
		</q-toolbar>

		<q-toolbar class="desktop-hide">
			<q-toolbar-title class="text-center">
				<div class="logo">
					<img :src="getLogo" class="logo-footer" />
				</div>
			</q-toolbar-title>
			<q-btn flat round dense @click="openMenu()" icon="fas fa-bars" />
		</q-toolbar>

		<q-modal
			v-model="show_modal"
			:content-css="{ minWidth: '80vw', maxWidth: '100vw', minHeight: '90vh' }"
			@hide="show_modal = false"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_modal = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('download_app') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table
						:data="codes"
						:columns="columns"
						@request="listCodes"
						:loading="loading"
						row-key="code"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						binary-state-sort
					>
						<template slot="top" slot-scope="props">
							<div class="col" />
							<q-btn
								color="primary"
								icon="fas fa-plus"
								@click="generateCode()"
								:label="$t('new_download_code')"
								:disable="disable_new_code"
							/>
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<q-tr slot="body" slot-scope="props" :props="props">
							<q-td key="redemption_link" :props="props">
								<q-btn
									flat
									icon="fas fa-download"
									color="primary"
									@click="openLink(getlink(props.row.redemption_link))"
								/>
							</q-td>

							<q-td key="code" :props="props">
								{{ props.row.code }}
							</q-td>

							<q-td key="created_date" :props="props">
								{{ fDate(props.row.created_date) }}
							</q-td>
						</q-tr>
					</q-table>
				</div>
			</q-modal-layout>
		</q-modal>
	</q-layout-footer>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'authenticated'] },

	data() {
		return {
			questions: [{ name: 'frequent_questions', to: 'faq' }, { name: 'help', to: 'help' }],
			institutional: [
				{ name: 'about_the_company', to: 'institutional-about' },
				{ name: 'privacy_policy', to: 'institutional-privacy' },
				{ name: 'terms_conditions', to: 'institutional-terms' },
			],
			loading: false,
			show_modal: false,
			codes: [],
			columns: [
				{
					name: 'redemption_link',
					required: true,
					label: 'download',
					align: 'left',
					field: 'redemption_link',
					sortable: false,
				},
				{
					name: 'code',
					required: true,
					label: 'redemption_code',
					align: 'left',
					field: 'code',
					sortable: false,
				},
				{
					name: 'created_date',
					required: true,
					label: 'creation_date',
					align: 'left',
					field: 'created_date',
					sortable: false,
				},
			],
			disable_new_code: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			logo: 'params/login_logo',
			register_fields: 'params/register_fields',
			user_clients: 'common/user_clients',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getLogo() {
			let obj = this.clients.find((obj) => {
				return obj.id == this.id_user_client_selected
			})

			if (obj && obj.logo_footer && obj.logo_footer !== 'https://image.jpg')
				return obj.logo_footer
			else return this.logo
		},

		links() {
			let links = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					links.push({
						name: obj.title_trainings == '' ? 'courses' : obj.title_trainings,
						to: 'courses',
					})

					links.push({
						name: obj.title_trails == '' ? 'trails' : obj.title_trails,
						to: 'trails',
					})

					links.push({
						name: obj.title_library == '' ? 'library' : obj.title_library,
						to: 'library',
					})

					links.push({
						name: obj.title_webcasts == '' ? 'webcasts' : obj.title_webcasts,
						to: 'webcasts',
					})
				}
			}
			return links
		},

		urlStoreGoogle() {
			if (process.env.APP_URL_GOOGLE) {
				if (this.$q.platform.is.cordova) return process.env.APP_URL_GOOGLE
				else
					return `https://play.google.com/store/apps/details?id=${process.env.CORDOVA_ID}`
			}
			return ''
		},

		urlStoreApple() {
			if (process.env.APP_URL_APPLE) {
				return process.env.APP_URL_APPLE
			}
			return ''
		},

		getProjectName() {
			return process.env.PROJECT_NAME
		},

		getVersion() {
			return process.env.APP_VERSION
		},

		useAppleCodes() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) return obj.use_apple_code
			}
			return false
		},
	},

	methods: {
		openMenu() {
			this.$store.dispatch('common/SET_RIGHT_MENU', [true])
		},

		clearDatatables() {
			this.$q.localStorage.remove('dataTableTags')
			this.$q.localStorage.remove('dataTableTrainings')
			this.$q.localStorage.remove('dataTableTrals')
			this.$q.localStorage.remove('dataTablelibraryCategories')
			this.$q.localStorage.remove('dataTableLibraries')
			this.$q.localStorage.remove('dataTableWebcast')
			this.$q.localStorage.remove('15-user-columns')
			this.$q.localStorage.remove('dataTableUsersGroups')
			this.$q.localStorage.remove('dataTableBranches')
			this.$q.localStorage.remove('dataTableQuestions')
			this.$q.localStorage.remove('dataTableTask')
			this.$q.localStorage.remove('dataTableSurveys')
			this.$q.localStorage.remove('dataTableMessages')
			this.$q.localStorage.remove('dataTableNews')
			this.$q.localStorage.remove('dataTableFaq')
			this.$q.localStorage.remove('dataTableFaqCategories')
			this.$q.localStorage.remove('dataTableBanners')
			this.$q.localStorage.remove('dataTableBannerWelcome')
			this.$q.localStorage.remove('dataTableHeadQuarters')
		},

		showLink(link) {
			if (this.id_user_client_selected) {
				let client = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (client) {
					switch (link) {
						case 'courses':
							return client.has_courses
							break
						case 'trails':
							return client.has_trails
							break
						case 'library':
							return client.has_library
							break
						case 'webcasts':
							return client.has_webcasts
							break
						default:
							return false
							break
					}
				}
			} else return false
		},

		open_modal() {
			this.show_modal = true
			this.disable_new_code = false
			this.listCodes()
		},

		listCodes() {
			this.$q.loading.show()

			this.$axios
				.get(`/admin_import/codes_app/list_user_code/`, this.getHeader)
				.then((response) => {
					this.codes = response.data.map((e) => {
						return {
							...e,
							code: e.code ? e.code : '',
							redemption_link: e.code,
						}
					})

					this.codes.reverse()
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					if (this.codes.length === 0) this.generateCode()
					else this.$q.loading.hide()
				})
		},

		generateCode() {
			this.$q.loading.show()

			this.$axios
				.post(`/admin_import/apple_code/`, {}, this.getHeader)
				.then((response) => {
					let e = response.data
					this.disable_new_code = true

					if (e) {
						this.codes.unshift({
							...e,
							code: e.code ? e.code : '',
							redemption_link: e.code,
						})
					}
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		getlink(code) {
			return `https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/freeProductCodeWizard?code=${code}`
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},

		openLink(link) {
			if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
				cordova.InAppBrowser.open(
					link,
					'_system',
					'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no'
				)
			} else {
				window.open(link, '_blank')
			}
		},

		filterLinks() {
			let hasFaq = false
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					hasFaq = obj.has_faq
				}
			}

			hasFaq
				? (this.questions = this.questions)
				: (this.questions = this.questions.filter((l) => l.to !== 'faq'))
		},
	},

	mounted() {
		this.filterLinks()
	},
}
</script>

<style lang="stylus" scoped>
@import '~variables'
p
    margin 0 0 10px

.logo-footer-desktop
    width auto
    height 35px
    -webkit-filter brightness(0) invert(1)
    filter brightness(0) invert(1)
    max-width 100%

.logo-footer
    width auto
    max-height 35px
    -webkit-filter brightness(0) invert(1)
    filter brightness(0) invert(1)
    max-width 100%

.redemption-link
    color #000000

a
    color #ffffff
    text-decoration none
</style>
